import React from 'react';
import classNames from 'classnames';
import { Theme, Skeleton } from '@mui/material';
import { WithStyles, withStyles, createStyles } from '@mui/styles';

interface AppSkeletonProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
    createStyles({
        page: {
            height: 'calc(100vh)',
            overflow: 'auto',
        },
        root: {
            padding: '0 60px',
            height: '100%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        },
        title: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: '158px',
            alignItems: 'center',
        },
        body: {
            marginTop: '168px',
            display: 'flex',
            flexDirection: 'column',
        },

        inputTitle: {
            marginBottom: '48px',
        },
        inputRoot: {
            alignSelf: 'center',
            marginBottom: '56px',
        },

        keyboard: {
            width: '494px !important',
            alignSelf: 'center',
            backgroundColor: 'white',
            // To include box-shadow of buttons
            paddingRight: '2px',
            paddingBottom: '2px',

            '& .hg-row:not(:last-child)': {
                marginBottom: '32px !important',
            },
        },
        keyboardRow: {
            display: 'flex',
            '&:not(:last-child)': {
                marginBottom: '32px',
            },
        },
        keyboardButton: {
            borderRadius: '5px',

            '&:not(:last-child)': {
                marginRight: '32px',
            },
        },

        footer: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '120px',
        },
        button: {
            borderRadius: '10px',
        },

        skeleton: {
            transform: 'none',
            transformOrigin: 'unset',
        },
    });

const WebPosAppSkeleton = (props: AppSkeletonProps) => {
    const { classes } = props;

    return (
        <div className={classes.page}>
            <div className={classes.root}>
                <div className={classes.title}>
                    <Skeleton
                        className={classes.skeleton}
                        height={72}
                        width={550}
                    />
                </div>
                <div className={classes.body}>
                    <Skeleton
                        className={classNames(
                            classes.skeleton,
                            classes.inputTitle
                        )}
                        height={32}
                        width={800}
                    />

                    <Skeleton
                        className={classNames(
                            classes.skeleton,
                            classes.inputRoot
                        )}
                        height={97}
                        width={494}
                    />
                    <Skeleton
                        className={classNames(
                            classes.skeleton,
                            classes.inputRoot
                        )}
                        height={97}
                        width={494}
                    />

                    {/* Keyboard */}
                    <div className={classes.keyboard}>
                        <div className={classes.keyboardRow}>
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                        </div>
                        <div className={classes.keyboardRow}>
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                        </div>
                        <div className={classes.keyboardRow}>
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                        </div>
                        <div className={classes.keyboardRow}>
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                            <Skeleton
                                className={classNames(
                                    classes.skeleton,
                                    classes.keyboardButton
                                )}
                                width={140}
                                height={96}
                            />
                        </div>
                    </div>
                </div>
                <div className={classes.footer}>
                    <Skeleton
                        className={classNames(classes.skeleton, classes.button)}
                        height={96}
                        width={200}
                    />
                    <Skeleton
                        className={classNames(classes.skeleton, classes.button)}
                        height={96}
                        width={200}
                    />
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles)(WebPosAppSkeleton);
